/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  Asset,
  AssetBase64Response,
  CreateAssetUploadedBody,
  FetchAssetFromUrlBody,
  FetchAssetFromUrlResponse,
  GetAssetsBatchResponse,
  GetAssetsResponse,
  GetAssetsSort,
  GetUploadAssetUrlBody,
  GetUploadAssetUrlResponse,
  SortOrder,
  StorageDetails,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    AssetFromJSON,
    AssetToJSON,
    AssetBase64ResponseFromJSON,
    AssetBase64ResponseToJSON,
    CreateAssetUploadedBodyFromJSON,
    CreateAssetUploadedBodyToJSON,
    FetchAssetFromUrlBodyFromJSON,
    FetchAssetFromUrlBodyToJSON,
    FetchAssetFromUrlResponseFromJSON,
    FetchAssetFromUrlResponseToJSON,
    GetAssetsBatchResponseFromJSON,
    GetAssetsBatchResponseToJSON,
    GetAssetsResponseFromJSON,
    GetAssetsResponseToJSON,
    GetAssetsSortFromJSON,
    GetAssetsSortToJSON,
    GetUploadAssetUrlBodyFromJSON,
    GetUploadAssetUrlBodyToJSON,
    GetUploadAssetUrlResponseFromJSON,
    GetUploadAssetUrlResponseToJSON,
    SortOrderFromJSON,
    SortOrderToJSON,
    StorageDetailsFromJSON,
    StorageDetailsToJSON,
} from '../models/index';

export interface CreateAssetsRequest {
    asset: Blob;
    name?: string;
    description?: string;
    contentType?: string;
}

export interface CreateAssetsFetchFromUrlRequest {
    fetchAssetFromUrlBody?: FetchAssetFromUrlBody;
}

export interface CreateAssetsGetUploadUrlRequest {
    getUploadAssetUrlBody?: GetUploadAssetUrlBody;
}

export interface CreateAssetsUploadedRequest {
    createAssetUploadedBody?: CreateAssetUploadedBody;
}

export interface DeleteAssetsIdRequest {
    id: string;
}

export interface GetAssetsRequest {
    search?: string;
    owner?: string;
    sort?: GetAssetsSort;
    order?: SortOrder;
    limit?: number;
    offset?: number;
    numberOfAvailableOffsets?: number;
}

export interface GetAssetsBase64UrlExtensionRequest {
    urlExtension: string;
}

export interface GetAssetsBatchRequest {
    ids: Array<string>;
}

export interface GetAssetsIdRequest {
    id: string;
}

export interface GetAssetsPipeUrlExtensionRequest {
    urlExtension: string;
}

export interface GetAssetsRedirectUrlExtensionRequest {
    urlExtension: string;
}

export interface UpdateAssetsIdRequest {
    id: string;
    asset?: Blob;
    name?: string;
    description?: string;
    contentType?: string;
}

/**
 * AssetsApi - interface
 * 
 * @export
 * @interface AssetsApiInterface
 */
export interface AssetsApiInterface {
    /**
     * Uploads an asset.
     * @param {Blob} asset The binary for the asset
     * @param {string} [name] 
     * @param {string} [description] 
     * @param {string} [contentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    createAssetsRaw(requestParameters: CreateAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>>;

    /**
     * Uploads an asset.
     */
    createAssets(requestParameters: CreateAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset>;

    /**
     * Fetch an image from an external URL and upload it to CDN (bypasses CORS)
     * @param {FetchAssetFromUrlBody} [fetchAssetFromUrlBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    createAssetsFetchFromUrlRaw(requestParameters: CreateAssetsFetchFromUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchAssetFromUrlResponse>>;

    /**
     * Fetch an image from an external URL and upload it to CDN (bypasses CORS)
     */
    createAssetsFetchFromUrl(requestParameters: CreateAssetsFetchFromUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchAssetFromUrlResponse>;

    /**
     * creates a write-only signed URL to upload an asset.
     * @param {GetUploadAssetUrlBody} [getUploadAssetUrlBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    createAssetsGetUploadUrlRaw(requestParameters: CreateAssetsGetUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUploadAssetUrlResponse>>;

    /**
     * creates a write-only signed URL to upload an asset.
     */
    createAssetsGetUploadUrl(requestParameters: CreateAssetsGetUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUploadAssetUrlResponse>;

    /**
     * Used to create an asset after uploading it.
     * @param {CreateAssetUploadedBody} [createAssetUploadedBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    createAssetsUploadedRaw(requestParameters: CreateAssetsUploadedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>>;

    /**
     * Used to create an asset after uploading it.
     */
    createAssetsUploaded(requestParameters: CreateAssetsUploadedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset>;

    /**
     * Deletes an existing asset
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    deleteAssetsIdRaw(requestParameters: DeleteAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes an existing asset
     */
    deleteAssetsId(requestParameters: DeleteAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Gets all assets this user has access to.
     * @param {string} [search] 
     * @param {string} [owner] 
     * @param {GetAssetsSort} [sort] 
     * @param {SortOrder} [order] 
     * @param {number} [limit] 
     * @param {number} [offset] 
     * @param {number} [numberOfAvailableOffsets] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsRaw(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetsResponse>>;

    /**
     * Gets all assets this user has access to.
     */
    getAssets(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetsResponse>;

    /**
     * Gets the base64 of a particular asset.
     * @param {string} urlExtension urlExtension of the asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsBase64UrlExtensionRaw(requestParameters: GetAssetsBase64UrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetBase64Response>>;

    /**
     * Gets the base64 of a particular asset.
     */
    getAssetsBase64UrlExtension(requestParameters: GetAssetsBase64UrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetBase64Response>;

    /**
     * Get multiple assets by IDs in a single request. Public endpoint, consistent with GET /assets/{id}.
     * @param {Array<string>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsBatchRaw(requestParameters: GetAssetsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetsBatchResponse>>;

    /**
     * Get multiple assets by IDs in a single request. Public endpoint, consistent with GET /assets/{id}.
     */
    getAssetsBatch(requestParameters: GetAssetsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetsBatchResponse>;

    /**
     * Get an existing asset.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsIdRaw(requestParameters: GetAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>>;

    /**
     * Get an existing asset.
     */
    getAssetsId(requestParameters: GetAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset>;

    /**
     * pipes the asset from Google Storage.
     * @param {string} urlExtension urlExtension of an asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsPipeUrlExtensionRaw(requestParameters: GetAssetsPipeUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * pipes the asset from Google Storage.
     */
    getAssetsPipeUrlExtension(requestParameters: GetAssetsPipeUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * pipes the asset from Google Storage.
     * @param {string} urlExtension urlExtension of an asset
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsRedirectUrlExtensionRaw(requestParameters: GetAssetsRedirectUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>>;

    /**
     * pipes the asset from Google Storage.
     */
    getAssetsRedirectUrlExtension(requestParameters: GetAssetsRedirectUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob>;

    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    getAssetsStorageDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageDetails>>;

    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     */
    getAssetsStorageDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageDetails>;

    /**
     * Updates an existing asset.
     * @param {string} id 
     * @param {Blob} [asset] The binary for the asset
     * @param {string} [name] 
     * @param {string} [description] 
     * @param {string} [contentType] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsApiInterface
     */
    updateAssetsIdRaw(requestParameters: UpdateAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>>;

    /**
     * Updates an existing asset.
     */
    updateAssetsId(requestParameters: UpdateAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset>;

}

/**
 * 
 */
export class AssetsApi extends runtime.BaseAPI implements AssetsApiInterface {

    /**
     * Uploads an asset.
     */
    async createAssetsRaw(requestParameters: CreateAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters['asset'] == null) {
            throw new runtime.RequiredError(
                'asset',
                'Required parameter "asset" was null or undefined when calling createAssets().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['asset'] != null) {
            formParams.append('asset', requestParameters['asset'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['contentType'] != null) {
            formParams.append('contentType', requestParameters['contentType'] as any);
        }


        let urlPath = `/assets`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * Uploads an asset.
     */
    async createAssets(requestParameters: CreateAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset> {
        const response = await this.createAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Fetch an image from an external URL and upload it to CDN (bypasses CORS)
     */
    async createAssetsFetchFromUrlRaw(requestParameters: CreateAssetsFetchFromUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FetchAssetFromUrlResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets/fetch-from-url`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchAssetFromUrlBodyToJSON(requestParameters['fetchAssetFromUrlBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FetchAssetFromUrlResponseFromJSON(jsonValue));
    }

    /**
     * Fetch an image from an external URL and upload it to CDN (bypasses CORS)
     */
    async createAssetsFetchFromUrl(requestParameters: CreateAssetsFetchFromUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FetchAssetFromUrlResponse> {
        const response = await this.createAssetsFetchFromUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * creates a write-only signed URL to upload an asset.
     */
    async createAssetsGetUploadUrlRaw(requestParameters: CreateAssetsGetUploadUrlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUploadAssetUrlResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets/get-upload-url`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: GetUploadAssetUrlBodyToJSON(requestParameters['getUploadAssetUrlBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUploadAssetUrlResponseFromJSON(jsonValue));
    }

    /**
     * creates a write-only signed URL to upload an asset.
     */
    async createAssetsGetUploadUrl(requestParameters: CreateAssetsGetUploadUrlRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUploadAssetUrlResponse> {
        const response = await this.createAssetsGetUploadUrlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create an asset after uploading it.
     */
    async createAssetsUploadedRaw(requestParameters: CreateAssetsUploadedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Admin", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets/uploaded`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateAssetUploadedBodyToJSON(requestParameters['createAssetUploadedBody']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * Used to create an asset after uploading it.
     */
    async createAssetsUploaded(requestParameters: CreateAssetsUploadedRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset> {
        const response = await this.createAssetsUploadedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an existing asset
     */
    async deleteAssetsIdRaw(requestParameters: DeleteAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteAssetsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an existing asset
     */
    async deleteAssetsId(requestParameters: DeleteAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssetsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all assets this user has access to.
     */
    async getAssetsRaw(requestParameters: GetAssetsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetsResponse>> {
        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['owner'] != null) {
            queryParameters['owner'] = requestParameters['owner'];
        }

        if (requestParameters['sort'] != null) {
            queryParameters['sort'] = requestParameters['sort'];
        }

        if (requestParameters['order'] != null) {
            queryParameters['order'] = requestParameters['order'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['offset'] != null) {
            queryParameters['offset'] = requestParameters['offset'];
        }

        if (requestParameters['numberOfAvailableOffsets'] != null) {
            queryParameters['numberOfAvailableOffsets'] = requestParameters['numberOfAvailableOffsets'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetsResponseFromJSON(jsonValue));
    }

    /**
     * Gets all assets this user has access to.
     */
    async getAssets(requestParameters: GetAssetsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetsResponse> {
        const response = await this.getAssetsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the base64 of a particular asset.
     */
    async getAssetsBase64UrlExtensionRaw(requestParameters: GetAssetsBase64UrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetBase64Response>> {
        if (requestParameters['urlExtension'] == null) {
            throw new runtime.RequiredError(
                'urlExtension',
                'Required parameter "urlExtension" was null or undefined when calling getAssetsBase64UrlExtension().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/base-64/{urlExtension}`;
        urlPath = urlPath.replace(`{${"urlExtension"}}`, encodeURIComponent(String(requestParameters['urlExtension'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetBase64ResponseFromJSON(jsonValue));
    }

    /**
     * Gets the base64 of a particular asset.
     */
    async getAssetsBase64UrlExtension(requestParameters: GetAssetsBase64UrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetBase64Response> {
        const response = await this.getAssetsBase64UrlExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get multiple assets by IDs in a single request. Public endpoint, consistent with GET /assets/{id}.
     */
    async getAssetsBatchRaw(requestParameters: GetAssetsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssetsBatchResponse>> {
        if (requestParameters['ids'] == null) {
            throw new runtime.RequiredError(
                'ids',
                'Required parameter "ids" was null or undefined when calling getAssetsBatch().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['ids'] != null) {
            queryParameters['ids'] = requestParameters['ids'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/batch`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssetsBatchResponseFromJSON(jsonValue));
    }

    /**
     * Get multiple assets by IDs in a single request. Public endpoint, consistent with GET /assets/{id}.
     */
    async getAssetsBatch(requestParameters: GetAssetsBatchRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssetsBatchResponse> {
        const response = await this.getAssetsBatchRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get an existing asset.
     */
    async getAssetsIdRaw(requestParameters: GetAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getAssetsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * Get an existing asset.
     */
    async getAssetsId(requestParameters: GetAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset> {
        const response = await this.getAssetsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * pipes the asset from Google Storage.
     */
    async getAssetsPipeUrlExtensionRaw(requestParameters: GetAssetsPipeUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['urlExtension'] == null) {
            throw new runtime.RequiredError(
                'urlExtension',
                'Required parameter "urlExtension" was null or undefined when calling getAssetsPipeUrlExtension().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/pipe/{urlExtension}`;
        urlPath = urlPath.replace(`{${"urlExtension"}}`, encodeURIComponent(String(requestParameters['urlExtension'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * pipes the asset from Google Storage.
     */
    async getAssetsPipeUrlExtension(requestParameters: GetAssetsPipeUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getAssetsPipeUrlExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * pipes the asset from Google Storage.
     */
    async getAssetsRedirectUrlExtensionRaw(requestParameters: GetAssetsRedirectUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters['urlExtension'] == null) {
            throw new runtime.RequiredError(
                'urlExtension',
                'Required parameter "urlExtension" was null or undefined when calling getAssetsRedirectUrlExtension().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/assets/redirect/{urlExtension}`;
        urlPath = urlPath.replace(`{${"urlExtension"}}`, encodeURIComponent(String(requestParameters['urlExtension'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.BlobApiResponse(response);
    }

    /**
     * pipes the asset from Google Storage.
     */
    async getAssetsRedirectUrlExtension(requestParameters: GetAssetsRedirectUrlExtensionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getAssetsRedirectUrlExtensionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     */
    async getAssetsStorageDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StorageDetails>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/assets/storage-details`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StorageDetailsFromJSON(jsonValue));
    }

    /**
     * Used to tell how much storage space the user has used, has left, and what the total amount allowed is.
     */
    async getAssetsStorageDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StorageDetails> {
        const response = await this.getAssetsStorageDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates an existing asset.
     */
    async updateAssetsIdRaw(requestParameters: UpdateAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Asset>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateAssetsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['asset'] != null) {
            formParams.append('asset', requestParameters['asset'] as any);
        }

        if (requestParameters['name'] != null) {
            formParams.append('name', requestParameters['name'] as any);
        }

        if (requestParameters['description'] != null) {
            formParams.append('description', requestParameters['description'] as any);
        }

        if (requestParameters['contentType'] != null) {
            formParams.append('contentType', requestParameters['contentType'] as any);
        }


        let urlPath = `/assets/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetFromJSON(jsonValue));
    }

    /**
     * Updates an existing asset.
     */
    async updateAssetsId(requestParameters: UpdateAssetsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Asset> {
        const response = await this.updateAssetsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
